<template>
  <section class="bg-white header">
    <div class="menu-header">
      <div class="header-top">
        <div class="header-left">
          <Tag
            type="primary"
            outline
            size="small"
            class="mr-2 menu-header-tag"
            v-if="categoryTag"
          >
            {{ categoryTag }}
          </Tag>
          <div class="menu-id sm:mb-1 sm:w-full" v-if="menuBasicInfo && menuBasicInfo.menuNo">
            [メニューNo. {{ menuBasicInfo.menuNo }}]
          </div>
        </div>
        <div class="header-right">
          <Share
            :facebook="false"
            :twitter="false"
            :line="false"
            :email="false"
            :social="false"
            :key="router"
            :menuBasicInfo="value" />
        </div>
      </div>
      <h1 class="menu-title" v-if="menuBasicInfo && menuBasicInfo.menuNm && this.$route.name === 'Menu Detail'">
        <a-tooltip>
          <template slot="title">
            <!-- {{ menuBasicInfo.menuNm | capitalize }} -->
            <span v-html="menuBasicInfo.menuNm.replaceAll('\n', '<br>')"> </span>
          </template>
          <!-- {{ menuBasicInfo.menuNm | capitalize }} -->
          <span v-html="menuBasicInfo.menuNm.replaceAll('\n', '<br>')"> </span>
        </a-tooltip>
      </h1>
      <h1 class="menu-title" v-else-if="menuBasicInfo && menuBasicInfo.menuNm">
        <a-tooltip>
          <template slot="title">
            <!-- {{ menuBasicInfo.menuNm | capitalize }} -->
            <span v-html="menuBasicInfo.menuNm.replaceAll('\n', '<br>')"> </span>
          </template>
          <!-- {{ menuBasicInfo.menuNm | capitalize }} -->
          <span v-html="menuBasicInfo.menuNm.replaceAll('\n', '<br>')"> </span>
        </a-tooltip>
      </h1>
      <!-- Placeholder for 割引 / クーポン / その他優待情報 -->
      <!-- <div class="header-otherinfo sm:hidden">
        割引 / クーポン / その他優待情報
      </div> -->
      <div class="header-meta sm:flex sm:justify-between sm:flex-wrap" style="width: 100%;">
        <div class="meta-item inline-flex mr-4" v-if="getAreaName">
          <i class="icon icon-bor-pin pt-1 pr-2 sm:pr-1" />
          <span class="text">
            {{ areaNmDtl }}
          </span>
        </div>

        <div class="icons">
          <div
            v-for="(flag, index) in getUsageDetails(menuBasicInfo)"
            :key="`usage-flag-${index}`"
          >
            <Tag 
              size="small"
              :class="[ flag.label === 'カフェ' || flag.label === '補助クーポン' ? 'mr-1 cafe-icon' : 'mr-1' ]" 
            >
              {{ flag.label }}
            </Tag>
          </div>
        </div>
        <button class="c-btn btn-white btn-sm map-btn-wrapper" @click="gotoMap" v-if="hasCoordinates">
          <span class="sm:hidden block">地図を見る</span>
          <span class="sm:block hidden map-btn-text">地図</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import _ from 'lodash'
import Share from '../components/Share'

export default {
  name: 'PlanDetailHeader',
  components: {
    Share
  },
  props: ['value', 'bodyEmail'],
  data() {
    return {
      idFavorite: '',
      showPopup: false,
      inWishList: false,
      menuBasicInfo: null,
      planIcons: null,
      statusFavorite: false,
      areaNmDtl: '',
      contentEmail : null
    }
  },
  created() {
    if (this.value) {
      this.menuBasicInfo = this.value
      this.setData()
    }
  },
  mounted() {},
  watch: {
    value(val) {
      this.menuBasicInfo = val
      this.setData()
      this.areaNmDtl = this.getArea
      this.contentEmail = {
        memberName: '',
        menuNo: _.get(val, 'menuNo', null),
        menuNm: _.get(val, 'menuNm', null),
        planId: '',
        roomId: '',
        planNm: ''
      }
    },
    bodyEmail(val) {
      if(!!val && !this.contentEmail) {
        this.contentEmail =  _.cloneDeep(this.bodyEmai);
      }
    }
  },
  methods: {
    setData() {
      if (this.menuBasicInfo) {
        this.planIcons = this.menuBasicInfo.planIcons
      }
    },
    gotoMap() {
      const { latitude, longitude } = _.get(this.menuBasicInfo, 'areaInfomation', {})
      if (latitude && longitude) {
        window.open(`https://maps.google.com/?q=${latitude},${longitude}`)
      }
    },
    copyContent() {
      return location.href
    },
    copySuccess() {
      this.$toasted.success('Copied')
    },
    copyError() {
      this.$toasted.error('Copy failed')
    },
    getUsageDetails(menuBasicInfo) {
      if(!menuBasicInfo) return []

      const tempIcons = [] ;
      // tempIcons = _.cloneDeep(this.planIcons) || []

      // 補助クーポンアイコンの表示制御
      if(menuBasicInfo.subsidyIcon){
        var iconNm = "補助クーポン"
        if ( tempIcons.findIndex(icon => icon.iconNm === iconNm) == -1){
          tempIcons.push({ iconCD : "subsidy", iconNm, iconSuppl : null });
        }
      }

      // カフェアイコンの表示制御
      if(menuBasicInfo.cafeSubscriptionIcon){
        var iconNm = "カフェ"
        if ( tempIcons.findIndex(icon => icon.iconNm === iconNm) == -1){
          tempIcons.push({ iconCD: "cafe", iconNm, iconSuppl: null })
        }
      }

      // 表示オブジェクト生成
      const activeFlags = []
      for (const icon of tempIcons) {
        const iconNm  = icon.iconNm
        if ( activeFlags.findIndex(i => i.value === iconNm) == -1){
          activeFlags.push({ label: iconNm, value: iconNm })
        }
      }

      return activeFlags
    }
  },
  computed: {
    hasCoordinates() {
      return (
        _.get(this.menuBasicInfo, 'areaInfomation.latitude', null) &&
        _.get(this.menuBasicInfo, 'areaInfomation.longitude', null)
      )
    },
    getAreaName() {
      // areaMidClassNm > areaDtlClassNm
      if (this.menuBasicInfo && this.menuBasicInfo.areaInfomation) {
        const areaMidClassNm = this.menuBasicInfo.areaInfomation.areaMidClassNm
        const areaDtlClassNm = this.menuBasicInfo.areaInfomation.areaDtlClassNm
        return `${areaMidClassNm ? `${areaMidClassNm}` : ''}${
          areaMidClassNm && areaDtlClassNm ? ' > ' : ''
        }${areaDtlClassNm ? `${areaDtlClassNm}` : ''}`
      }
      return ''
    },
    getArea() {
      let areaNm = ''
      if (_.get(this.menuBasicInfo, 'areaInfomation.areaMidClassNm')) {
        areaNm += _.get(this.menuBasicInfo, 'areaInfomation.areaMidClassNm')
      }
      if (_.get(this.menuBasicInfo, 'areaInfomation.areaSmlClassNm')) {
        if (areaNm) {
          areaNm += ' > '
        }
        areaNm += _.get(this.menuBasicInfo, 'areaInfomation.areaSmlClassNm')
      }
      if (_.get(this.menuBasicInfo, 'areaInfomation.areaDtlClassNm')) {
        if (areaNm) {
          areaNm += ' > '
        }
        areaNm += _.get(this.menuBasicInfo, 'areaInfomation.areaDtlClassNm')
      }
      return areaNm
    },
    getUserInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'auth', null))
    },
    categoryTag() {
      let categoryNm = ''
      if (_.get(this.menuBasicInfo, 'categoryInfomation.catLrgClassNm')) {
        categoryNm += _.get(this.menuBasicInfo, 'categoryInfomation.catLrgClassNm')
      }
      if (_.get(this.menuBasicInfo, 'categoryInfomation.catMidClassNm')) {
        if (categoryNm) {
          categoryNm += '・'
        }
        categoryNm += _.get(this.menuBasicInfo, 'categoryInfomation.catMidClassNm')
      }
      if (_.get(this.menuBasicInfo, 'categoryInfomation.catSmlClassNm')) {
        if (categoryNm) {
          categoryNm += '・'
        }
        categoryNm += _.get(this.menuBasicInfo, 'categoryInfomation.catSmlClassNm')
      }
      return categoryNm
    },
    router() {
      return this.$route.fullPath
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';

.icons {
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
}

.cafe-icon {
  color: #f4f5f6 !important;
  background-color: #0d76bf !important;
}

.menu-title {
  p {
      display: block;
      font-weight: 600;
      font-size: small;
      color: #73767a;
    }
}
</style>
